import { CONFIGURATION_TYPE } from '@/constants'

const CONFIGURATOR_MODE = {
  EDIT: 'edit',
  CREATE: 'create',
}

const MENU_GROUPS = [{ id: 'colors', label: 'colors', afterStep: 'safety' }]

const STEPS_BY_TYPE = {
  [CONFIGURATION_TYPE.FULL]: [
    'style',
    'material',
    'profile',
    'windowType',
    'windowOpeningType',
    'safety',
    'colorInner',
    'colorOuter',
    'sizeAndQuantity',
    /*'innovations',*/
  ],
  [CONFIGURATION_TYPE.PROJECT]: [
    'files',
    'style',
    'material',
    'profile',
    'safety',
    'colorInner',
    'colorOuter',
    'configurationName',
    /*'innovations',*/
  ],
}

export { STEPS_BY_TYPE, CONFIGURATOR_MODE, MENU_GROUPS }
